// Microsoft Clarity loader.
//
// Injects the standard Clarity script tag and stubs `window.clarity` as a
// queue function so calls made before the script finishes loading are
// captured. Safe to call multiple times — subsequent calls short-circuit.
//
// Clarity has NO JavaScript API for masking. PII is masked via:
//   1. CSS selectors configured in the Clarity dashboard, or
//   2. `data-clarity-mask="True"` attributes on sensitive DOM nodes.
export function loadClarity(projectId: string): void {
  if (typeof window === "undefined") return;
  const w = window as unknown as {
    clarity?: ((...args: unknown[]) => void) & { q?: unknown[] };
  };
  if (w.clarity) return;
  const fn = function (this: unknown, ...args: unknown[]) {
    (fn.q = fn.q || []).push(args);
  } as ((...args: unknown[]) => void) & { q?: unknown[] };
  w.clarity = fn;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${projectId}`;
  (document.head ?? document.documentElement).appendChild(script);
}
